import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children, adminOnly = false, blockRoles = [] }) => {
  const { user, loading } = useAuth();

  if (loading)
    return (
      <div
        data-testid="auth-loading"
        className="flex min-h-screen items-center justify-center bg-[#0B0C10] text-[#94A3B8] font-body"
      >
        A verificar sessão…
      </div>
    );

  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (blockRoles.includes(user.role))
    return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
  return children;
};
